"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTrash = require("@fortawesome/pro-regular-svg-icons/faTrash");

var _faCircleNotch = require("@fortawesome/pro-regular-svg-icons/faCircleNotch");

var _faExclamationTriangle = require("@fortawesome/pro-regular-svg-icons/faExclamationTriangle");

var _reactToastify = require("react-toastify");

var _Modal = _interopRequireDefault(require("../../Modal"));

var _client = require("@peracto/client");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var contentURLs = ['pages', 'articles', 'templates', 'elements'];

var EditRows = function EditRows(_ref) {
  var selectedRows = _ref.selectedRows,
      instance = _ref.instance,
      reloadData = _ref.reloadData,
      _ref$allowDuplicate = _ref.allowDuplicate,
      allowDuplicate = _ref$allowDuplicate === void 0 ? false : _ref$allowDuplicate,
      history = _ref.history;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      errors = _useState2[0],
      setErrors = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showDeleteModal = _useState4[0],
      setShowDeleteModal = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showDuplicateModal = _useState6[0],
      setShowDuplicateModal = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      isDeleting = _useState8[0],
      setIsDeleting = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isDuplicating = _useState10[0],
      setIsDuplicating = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = _slicedToArray(_useState11, 2),
      duplicateRedirectUrl = _useState12[0],
      setDuplicateRedirectUrl = _useState12[1];

  var _useClient = (0, _client.useClient)(),
      client = _useClient.client;

  (0, _react.useEffect)(function () {
    if (showDuplicateModal || showDeleteModal) {
      setErrors([]);
    }
  }, [showDuplicateModal, showDeleteModal]);

  var onDuplicate = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var url, updatedContents, _data$, data, _ref3, originId, type, _e$error, _e$error$body, _e$error2, _e$error2$body;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setIsDuplicating(true);
              url = window.location.pathname.replace(/\//g, '');
              updatedContents = [];

              if (contentURLs.includes(url)) {
                url = 'contents';
              }

              if (url === 'variants') {
                url = 'product-variants';
              }

              selectedRows.forEach(function (row) {
                var _instance$data, _content$contentProdu;

                var content = instance === null || instance === void 0 ? void 0 : (_instance$data = instance.data) === null || _instance$data === void 0 ? void 0 : _instance$data.find(function (content) {
                  return (content === null || content === void 0 ? void 0 : content.originId) === parseInt(row);
                });
                var contentProductLinks = []; // Used for managing content product links as API only accepts the data in this format

                content === null || content === void 0 ? void 0 : (_content$contentProdu = content.contentProductLinks) === null || _content$contentProdu === void 0 ? void 0 : _content$contentProdu.forEach(function (contentProductLink) {
                  contentProductLinks === null || contentProductLinks === void 0 ? void 0 : contentProductLinks.push({
                    product: contentProductLink === null || contentProductLink === void 0 ? void 0 : contentProductLink.product['@id'],
                    productDisplayOrder: contentProductLink === null || contentProductLink === void 0 ? void 0 : contentProductLink.productDisplayOrder
                  });
                }); // Rename name and slug to identify as copy

                var updatedContent = _objectSpread(_objectSpread({}, content), {}, {
                  name: "Copy of ".concat(content === null || content === void 0 ? void 0 : content.name),
                  slug: "copy-of-".concat(content === null || content === void 0 ? void 0 : content.slug),
                  contentProductLinks: contentProductLinks
                }); // Delete unique data


                delete updatedContent['@id'];
                delete updatedContent['@type'];
                updatedContent === null || updatedContent === void 0 ? true : delete updatedContent.id;
                updatedContent === null || updatedContent === void 0 ? true : delete updatedContent.originId;
                updatedContent === null || updatedContent === void 0 ? true : delete updatedContent.createdAt;
                updatedContent === null || updatedContent === void 0 ? true : delete updatedContent.publishedAt;
                updatedContent === null || updatedContent === void 0 ? true : delete updatedContent.modifiedAt;
                updatedContent === null || updatedContent === void 0 ? true : delete updatedContent.modifiedBy;
                updatedContents.push(client(_client.CREATE, url, {
                  data: _objectSpread({}, updatedContent)
                }));
              });
              _context.prev = 6;
              _context.next = 9;
              return Promise.all(updatedContents);

            case 9:
              data = _context.sent;
              setShowDuplicateModal(false);
              setIsDuplicating(false);
              instance.toggleRowSelectedAll(false);
              reloadData();
              _ref3 = (data === null || data === void 0 ? void 0 : data.length) > 0 && ((_data$ = data[0]) === null || _data$ === void 0 ? void 0 : _data$.data), originId = _ref3.originId, type = _ref3.type;
              setDuplicateRedirectUrl("content/edit/".concat(type, "/").concat(originId.toString()));
              _context.next = 24;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](6);
              if (process.env.NODE_ENV === 'development') console.error(_context.t0);
              setErrors([].concat(_toConsumableArray(errors), [_context.t0 !== null && _context.t0 !== void 0 && (_e$error = _context.t0.error) !== null && _e$error !== void 0 && (_e$error$body = _e$error.body) !== null && _e$error$body !== void 0 && _e$error$body.hasOwnProperty('hydra:description') ? _context.t0.error.body['hydra:description'] : 'Whoops, there was a problem...']));
              setIsDuplicating(false);

              _reactToastify.toast.error(_context.t0 !== null && _context.t0 !== void 0 && (_e$error2 = _context.t0.error) !== null && _e$error2 !== void 0 && (_e$error2$body = _e$error2.body) !== null && _e$error2$body !== void 0 && _e$error2$body.hasOwnProperty('hydra:description') ? _context.t0.error.body['hydra:description'] : 'Whoops, there was a problem...');

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 18]]);
    }));

    return function onDuplicate() {
      return _ref2.apply(this, arguments);
    };
  }();

  var onDelete = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var url, ids, _e$error3, _e$error3$body, _e$error4, _e$error4$body;

      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsDeleting(true);
              url = window.location.pathname.replace(/\//g, '');
              ids = [];

              if (contentURLs.includes(url)) {
                url = 'contents';
              }

              if (url === 'variants') {
                url = 'product-variants';
              }

              selectedRows.forEach(function (row) {
                ids.push(client(_client.DELETE, url, {
                  id: "".concat(url, "/").concat(row)
                }));
              });
              _context2.prev = 6;
              _context2.next = 9;
              return Promise.all(ids);

            case 9:
              setShowDeleteModal(false);
              setIsDeleting(false);
              instance.toggleRowSelectedAll(false);
              reloadData();
              _context2.next = 21;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](6);
              if (process.env.NODE_ENV === 'development') console.error(_context2.t0);
              setErrors([].concat(_toConsumableArray(errors), [_context2.t0 !== null && _context2.t0 !== void 0 && (_e$error3 = _context2.t0.error) !== null && _e$error3 !== void 0 && (_e$error3$body = _e$error3.body) !== null && _e$error3$body !== void 0 && _e$error3$body.hasOwnProperty('hydra:description') ? _context2.t0.error.body['hydra:description'] : 'Whoops, there was a problem...']));
              setIsDeleting(false);

              _reactToastify.toast.error(_context2.t0 !== null && _context2.t0 !== void 0 && (_e$error4 = _context2.t0.error) !== null && _e$error4 !== void 0 && (_e$error4$body = _e$error4.body) !== null && _e$error4$body !== void 0 && _e$error4$body.hasOwnProperty('hydra:description') ? _context2.t0.error.body['hydra:description'] : 'Whoops, there was a problem...');

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 15]]);
    }));

    return function onDelete() {
      return _ref4.apply(this, arguments);
    };
  }();

  var hasErrors = errors.length > 0;
  var primaryButtonText = '';
  if (isDeleting) primaryButtonText = 'Deleting...';
  if (isDuplicating) primaryButtonText = 'Duplicating...';

  if (hasErrors && !isDeleting && !isDuplicating) {
    primaryButtonText = 'Cancel';
  } else {
    if (showDeleteModal) primaryButtonText = "Delete Row".concat(selectedRows.length !== 1 ? "s" : '');
    if (showDuplicateModal) primaryButtonText = "Duplicate Row".concat(selectedRows.length !== 1 ? "s" : '');
  }

  var modalContent;
  if (hasErrors && !isDeleting && !isDuplicating) modalContent = errors.join('\n\n');else {
    if (showDeleteModal) {
      modalContent = "Are you sure you would like to permanently delete the ".concat(selectedRows.length, " selected row").concat(selectedRows.length !== 1 ? "s" : '', "?");
    }

    if (showDuplicateModal) {
      modalContent = "Are you sure you would like to duplicate the selected row?";
    }
  }

  if (duplicateRedirectUrl) {
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
      to: duplicateRedirectUrl
    });
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faTrash.faTrash,
    size: "1x",
    className: "mr-2"
  }), /*#__PURE__*/_react["default"].createElement("p", null, "Edit ", selectedRows.length, " row", selectedRows.length != 1 && "s", ".")), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-outline-secondary mr-2 btn-cancel-delete",
    onClick: function onClick() {
      return instance.toggleRowSelectedAll(false);
    },
    "data-testid": "cancel-delete-button"
  }, "Cancel"), allowDuplicate && (selectedRows === null || selectedRows === void 0 ? void 0 : selectedRows.length) < 2 && /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-outline-primary btn-open-modal mr-2",
    onClick: function onClick() {
      return setShowDuplicateModal(true);
    },
    "data-testid": "duplicate-button"
  }, "Duplicate"), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-danger btn-open-modal",
    onClick: function onClick() {
      return setShowDeleteModal(true);
    },
    "data-testid": "delete-button"
  }, "Delete"), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isVisible: showDuplicateModal,
    title: "Duplicate Row",
    close: function close() {
      return setShowDuplicateModal(false);
    },
    buttons: [{
      type: 'btn-outline-secondary',
      text: 'Close',
      action: function action() {
        return setShowDuplicateModal(false);
      }
    }, {
      type: 'btn-primary',
      text: primaryButtonText,
      disabled: isDuplicating,
      action: function action() {
        if (hasErrors) {
          setShowDuplicateModal(false);
          instance.toggleRowSelectedAll(false);
        } else {
          onDuplicate();
        }
      }
    }]
  }, isDuplicating ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faCircleNotch.faCircleNotch,
    size: "4x",
    spin: true,
    className: "d-block mb-4"
  }), "Duplicating.....") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faExclamationTriangle.faExclamationTriangle,
    size: "4x",
    className: "d-block mb-4"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "duplicate-warning"
  }, modalContent))), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isVisible: showDeleteModal,
    title: "Delete Rows",
    close: function close() {
      return setShowDeleteModal(false);
    },
    buttons: [{
      type: 'btn-outline-secondary',
      text: 'Close',
      action: function action() {
        return setShowDeleteModal(false);
      }
    }, {
      type: hasErrors ? 'btn-outline-secondary' : 'btn-danger',
      text: primaryButtonText,
      disabled: isDeleting,
      action: function action() {
        if (hasErrors) {
          setShowDeleteModal(false);
          instance.toggleRowSelectedAll(false);
        } else {
          onDelete();
        }
      }
    }]
  }, isDeleting ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faCircleNotch.faCircleNotch,
    size: "4x",
    spin: true,
    className: "d-block mb-4"
  }), "Deleting.....") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faExclamationTriangle.faExclamationTriangle,
    size: "4x",
    className: "d-block mb-4"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "delete-warning"
  }, modalContent)))));
};

var _default = EditRows;
exports["default"] = _default;